import { loadable } from "components/SpruceLoader";

export const Spawn = loadable(() => import("./spawn/index"));
